import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/ilustrations/verificar-email.gif'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "256",
  width: "256"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "content" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Verificação de email"),
  /*#__PURE__*/_createElementVNode("p", null, "Para contas criadas com email e senha é necessário confirmar o endereço de email fornecido."),
  /*#__PURE__*/_createElementVNode("p", null, "Após criar a sua conta, um email foi automaticamente enviado para a sua caixa de entrada (verifique também o spam), confira-o e siga as instruções fornecidas para confirmar a sua conta."),
  /*#__PURE__*/_createElementVNode("p", null, "Caso não tenha conseguido encontrar o email, você pode solicitar um novo envio pelo botão abaixo.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("article", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_Button, {
      disabled: _ctx.buttonDisabled,
      "button-text": 'Reenviar email de autenticação',
      "has-icon": 'No',
      onClick: _ctx.handleButtonClick
    }, null, 8, ["disabled", "onClick"])
  ]))
}